import { apiClient } from "api";
import {
  TContact,
  TContactPicklist,
  TContractGroupPicklist,
  TEditContact,
  TEditContactEmail,
  TVTDialedNumberMap,
  TVTUser
} from "./models/types";

export const getAllContractGroupsList = async (): Promise<TContractGroupPicklist[]> => {
  return apiClient.get("contacts/groups/list").then(reponse => reponse.data);
};

export const getAllContactsList = async (accountId: string): Promise<TContactPicklist[]> => {
  return apiClient.get(`contacts/list/${accountId}`).then(reponse => reponse.data);
};

export const getContactsForAccount = async (accountId: string): Promise<TContact[]> => {
  const response = await apiClient.get(`contacts/${accountId}`);
  return response.data;
};

export const getContactById = async (
  accountId: string,
  contactId: number
): Promise<TEditContact> => {
  const response = await apiClient.get(`contacts/edit/${accountId}/${contactId}`);
  return response.data;
};

export const addOrUpdateContact = async (contact: TEditContact): Promise<TContact> => {
  const response = await apiClient({
    method: contact.contactId ? "put" : "post",
    url: `contacts`,
    data: contact
  });
  return response.data;
};

export const addOrUpdateContactEmail = async (contact: TEditContactEmail): Promise<TContact> => {
  const response = await apiClient({
    method: "patch",
    url: `contacts`,
    data: contact
  });
  return response.data;
};

export const getDialedNumbers = async (): Promise<TVTDialedNumberMap[]> => {
  const response = await apiClient.get("vtusers/dialedNumbers");
  return response.data;
};

export const getVTUser = async (accountId: string, contactId: number): Promise<TVTUser> => {
  const response = await apiClient.get(`vtusers/${accountId}/${contactId}`);
  return response.data;
};

export const isVTUserIdTaken = async (
  userId: string,
  dialedNumber: string
): Promise<boolean> => {
  const response = await apiClient.get(`vtusers/isTaken/${userId}/${dialedNumber}`);
  return response.data;
};

export const getAvailableVTUserIds = async (
  startUserId: number,
  endUserId: number,
  dialedNumber: string
): Promise<string[]> => {
  const response = await apiClient.get(
    `vtusers/available-user-ids/${dialedNumber}/${startUserId}/${endUserId}`
  );
  return response.data;
};

export const addOrUpdateVTUser = (vtUser: TVTUser, isNew: boolean): Promise<string> => {
  return apiClient({
    method: isNew ? "post" : "put",
    url: `vtusers`,
    data: vtUser
  });
};
